import script from "./marketing.vue?vue&type=script&setup=true&lang=js"
export * from "./marketing.vue?vue&type=script&setup=true&lang=js"

import "./marketing.vue?vue&type=style&index=0&id=5c657217&lang=less&scoped=true"

import exportComponent from "D:\\workspace\\payment-system-merchant\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c657217"]])

export default __exports__